/** FR76 3000 6000 0112 3456 7890 189 — the API stores IBANs without spaces. */
export const groupIban = (iban: string): string => iban.replace(/(.{4})/g, '$1 ').trim();
